import type { LoginTypeRes } from '@/types/api/user/auth/login-type';
import { atom } from 'jotai';

export const loginTypesAtom = atom<LoginTypeRes['items']>([]);